import { WebGLComponent } from './webgl-component';

export class Box extends WebGLComponent
{
  constructor(canvas: HTMLCanvasElement, model: Object, options: Object = {})
  {
    super(canvas, model, options);
  }

  public async updateSVGReference(
      svgReference: string | SVGElement): Promise<void>
  {
    this.model['boxTop'].svgReference = svgReference;
    try {
      await this.refreshSVGs();
    }
    catch (e) {
      console.error(e);
   }
  }
}
